import React, { useState } from "react";
import '../styles/Certificados.css';
// Simulación de consulta — reemplazar luego con fetch hacia tu backend con PostgreSQL
const DatosPersonal = {
  '44254507': {
    nombre: 'Celia Alviz Ataucuri',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_01.pdf',
  },
  '45811239': {
    nombre: 'Mylania Julie Anco Enriquez',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_02.pdf',
  },
  '74498416': {
    nombre: 'Franchesca T. Arias Muñoz',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_03.pdf',
  },
  '72213413': {
    nombre: 'Liz Anaith Aroni Aragon',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_04.pdf',
  },
  '74569809': {
    nombre: 'Nelly Batallanos Quispe',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_05.pdf',
  },
  '72557732': {
    nombre: 'Delia Carbajal Muñoz',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_07.pdf',
  },
  '77479540': {
    nombre: 'Wilbert Ccahuana Rimache',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_08.pdf',
  },
  '74396645': {
    nombre: 'Noemi Ccatuma Huamani',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_09.pdf',
  },
  '41732162': {
    nombre: 'Julio Roger Cconislla Choque',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_10.pdf',
  },
  '74282505': {
    nombre: 'Vicentina Soledad Chauca Cruz',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_11.pdf',
  },
  '74091777': {
    nombre: 'Alicia Choque Patiño',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_13.pdf',
  },
  '74615865': {
    nombre: 'Nayre Cjula Llicahua',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_14.pdf',
  },
  '77323313': {
    nombre: 'Cristhian Nico Coaquira Tacca',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_14_01.pdf',
  },
  '71904829': {
    nombre: 'Analy Collado Pauccara',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_16.pdf',
  },
  '72549040': {
    nombre: 'Yenny Karen Condori Mayanasa',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_18.pdf',
  },
  '74282573': {
    nombre: 'Veronica Cruz Choqqueccota',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_19.pdf',
  },
  '71794674': {
    nombre: 'Bill Clinton Cuba Gomez',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_20.pdf',
  },
  '74730017': {
    nombre: 'Sayda Cusi Abrigo',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_21.pdf',
  },
  '74903665': {
    nombre: 'Abel Sadam Flores Yahuira',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_22.pdf',
  },
  '41828967': {
    nombre: 'Guadalupe Gaimez Alvis',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_23.pdf',
  },
  '47581320': {
    nombre: 'Yecsi Yessenia Guerreros Triviños',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_24.pdf',
  },
  '47483458': {
    nombre: 'Juan Rusbel Hancco Mamani',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_25.pdf',
  },
  '45341569': {
    nombre: 'Diomira Huamani Challa',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_26.pdf',
  },
  '71794892': {
    nombre: 'Carla Katerine Huamani Guevara',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_27.pdf',
  },
  '74765525': {
    nombre: 'Edwin Huañahui Huanca',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_28.pdf',
  },
  '74349751': {
    nombre: 'Shermely Huaman Cabrera',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_29.pdf',
  },
  '47781680': {
    nombre: 'Luis Alberto Maccarcco Quispe',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_30.pdf',
  },
  '47781680': {
    nombre: 'Luis Alberto Maccarcco Quispe',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_30.pdf',
  },
  '72771222': {
    nombre: 'Liceth Yanira Mamani Huamani',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_31.pdf',
  },
  '47878676': {
    nombre: 'Rocio Mendoza Pfoccori',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_32.pdf',
  },
  '74545035': {
    nombre: 'Yeni Merma Silva',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_33.pdf',
  },
  '46510850': {
    nombre: 'Yina Molina Castro',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_34.pdf',
  },
  '47825534': {
    nombre: 'Maria de los Angeles Morales Olivera',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_35.pdf',
  },
  '71907225': {
    nombre: 'Rossy Pacco Lopez',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_36.pdf',
  },
  '62169527': {
    nombre: 'Cinthia Erlinda Quispe Condori',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_37.pdf',
  },
  '71780692': {
    nombre: 'Maria Elena Quispe Hilacundo',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_38.pdf',
  },
  '42157311': {
    nombre: 'Fredy Salas Castillo',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_39.pdf',
  },
  '47646604': {
    nombre: 'Silvestre Tinuco Chacnama',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_40.pdf',
  },
  '71796239': {
    nombre: 'Wildero Jose Toribio Llacma',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_41.pdf',
  },
  '72001939': {
    nombre: 'Selvi Masiel Tribiños Casco',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_42.pdf',
  },
  '45753656': {
    nombre: 'Diana Urbina Ancalla',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_43.pdf',
  },
  '75273552': {
    nombre: 'Alina Alexandra Venero Yupanqui',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_44.pdf',
  },
  '76464416': {
    nombre: 'Ambar Silvina Vilavila Contreras',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_45.pdf',
  },
  '75176324': {
    nombre: 'Verioska Areliz Vilca Salhua',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_46.pdf',
  },
  '76253335': {
    nombre: 'Yhonatan Smith Ylaccaña Cordova',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_47.pdf',
  },
  '74088619': {
    nombre: 'Kely Vanessa Zuñiga Calderon',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_48.pdf',
  },
  '73011227': {
    nombre: 'Flor De Maria Zuniga Pacco',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_49.pdf',
  },
  '76185446': {
    nombre: 'Jimena Lady Medina Cairo',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_50.pdf',
  },
  '74448278': {
    nombre: 'Miluska Kjuro Huamani',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_51.pdf',
  },
  '47293400': {
    nombre: 'Luz Cabrea Sacsi',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_52.pdf',
  },
  '77534315': {
    nombre: 'Avelina Calderon Zevallos',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_53.pdf',
  },
  '76171263': {
    nombre: 'Elaine Huanca Apaza',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_54.pdf',
  },
  '46460825': {
    nombre: 'Maribel Pezo Calderon',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_55.pdf',
  },
  '43232050': {
    nombre: 'Mery Boza Huayllani',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_56.pdf',
  },
  '71801237': {
    nombre: 'Rosa Angelica Arredondo Pezo',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_57.pdf',
  },
  '74505059': {
    nombre: 'Faustina Valdez Vallejos',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_58.pdf',
  },
  '76967189': {
    nombre: 'Jackelin Flor Apfata Torres',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_59.pdf',
  },
  '74896134': {
    nombre: 'Luis Miguel Abiega Carrillo',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_60.pdf',
  },
  '76121035': {
    nombre: 'Mariela Sivincha Polanco',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_61.pdf',
  },
  '74304003': {
    nombre: 'Daniela Valeria Huamani Huamani',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_62.pdf',
  },
  '74544589': {
    nombre: 'Aedeli Peña Cjuro',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_63.pdf',
  },
  '71904840': {
    nombre: 'Kevin Chaname Quispesivana Minga',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_64.pdf',
  },
  '76180756': {
    nombre: 'Rosa Flor Aimituma Denos',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_65.pdf',
  },
  '75226340': {
    nombre: 'Delia Maritza Pasca Casquina',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_66.pdf',
  },
  '76551936': {
    nombre: 'Floriza Chaco Alferez',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_67.pdf',
  },
  '47929653': {
    nombre: 'Margaret Soraida Ccosi Benito',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_68.pdf',
  },
  '42278834': {
    nombre: 'Johnny B. Chambi Vilcapaza',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_69.pdf',
  },
  '73598274': {
    nombre: 'Delia Huillca Mamani',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_70.pdf',
  },
  '74502314': {
    nombre: 'Rosmery Giraldo Ccoa',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_78.pdf',
  },
  '61390390': {
    nombre: 'Wilber Ruben Chavez Huamani',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_79.pdf',
  },
  '46979338': {
    nombre: 'Cesar Teofilo Guevara Inga',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_77.pdf',
  },
  '74765970': {
    nombre: 'Lisbeth Cabrera Solis',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_76.pdf',
  },
  '00493247': {
    nombre: 'Jose Luis Pimentel Zegarra',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_80.pdf',
  },
  '01307784': {
    nombre: 'Marco Aurelio Sandoval Torres',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_81.pdf',
  },
  '72170208': {
    nombre: 'Paul Bhriyan Vilca Vilca',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_82.pdf',
  },
  '43572782': {
    nombre: 'Mauro Serrano Quispe',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_83.pdf',
  },
  '46975529': {
    nombre: 'Elza Elisabet Aedo Morales',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_84.pdf',
  },
  '43349096': {
    nombre: 'Marcos Mollo Calsina',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_85.pdf',
  },
  '42043110': {
    nombre: 'Emilio Chino Chuño',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_86.pdf',
  },
  '42489535': {
    nombre: 'José Sierra Mejía',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_87.pdf',
  },
  '46354320': {
    nombre: 'Fredy Quispe Sumiri',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_88.pdf',
  },
  '70396576': {
    nombre: 'Alexander Pavel Ibarra Huaman',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_89.pdf',
  },
  '43612546': {
    nombre: 'Grover Moreano Briceño',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_90.pdf',
  },
  '80366026': {
    nombre: 'Wilver Quispe Hancco',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_91.pdf',
  },
  '46300448': {
    nombre: 'Santos Sullca Chuquitaipe',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_92.pdf',
  },
  '42782186': {
    nombre: 'Jesús Abraham Uchiri Quispe',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_93.pdf',
  },
  '40023507': {
    nombre: 'Mercedes Marisabel Arapa Fernandez',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_94.pdf',
  },
  '71905632': {
    nombre: 'Norma Pezo Huachaca',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_95.pdf',
  },
  '48058300': {
    nombre: 'Rocio Condori Enriquez',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_96.pdf',
  },
  '74081658': {
    nombre: 'Kelsy Ruth Alccahuaman Zuniga',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_97.pdf',
  },
  '73967999': {
    nombre: 'Celia Marleny Peña Vargas',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_98.pdf',
  },
  '76464163': {
    nombre: 'Luzgardo Huayhua Laime',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_99.pdf',
  },
  '74738807': {
    nombre: 'Mariela Carla Meléndez Huaman',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_100.pdf',
  },
  '73210614': {
    nombre: 'Susana Rosita Huamane Lopinta',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_101.pdf',
  },
  '71796538': {
    nombre: 'Yury Idalina Zuniga Ttito',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_102.pdf',
  },
  '74395866': {
    nombre: 'Ada Miriam Quispe Prieto',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_103.pdf',
  },
  '41284077': {
    nombre: 'Delia Aroni Huisa',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_104.pdf',
  },
  '48230429': {
    nombre: 'Elizabeth Moreano Sucno',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_105.pdf',
  },
  '40733914': {
    nombre: 'Luisa Vera Alvis',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_106.pdf',
  },
  '73975447': {
    nombre: 'Luz Maribel Pfoccoalata Callante',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_107.pdf',
  },
  '77533866': {
    nombre: 'Carmen Rosa Olayunca Amat',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_108.pdf',
  },
  '70522152': {
    nombre: 'Climaco Wilbert Huamani Chillpa',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_109.pdf',
  },
  '74456429': {
    nombre: 'Idalia Salcedo Arias',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_110.pdf',
  },
  '77380178': {
    nombre: 'Yeny Margot Llamocca Chaco',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_111.pdf',
  },
  '74081101': {
    nombre: 'Yeny Fernández Sivana',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_112.pdf',
  },
  '71791472': {
    nombre: 'Ely flor Peña Fernández',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_113.pdf',
  },
  '74149533': {
    nombre: 'Luz Marina Madariaga Mendoza',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_114.pdf',
  },
  '45304952': {
    nombre: 'Jose Guillermo Huahuatico Quintasi',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_115.pdf',
  },
  '71901841': {
    nombre: 'Luz Clarita Quispe Bautista',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_116.pdf',
  },
  '73648767': {
    nombre: 'Deyssi Kuper Armacta Challa',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_117.pdf',
  },
  '73970715': {
    nombre: 'Pither Abimael Morales Salhua',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_74.pdf',
  },
  '43497696': {
    nombre: 'Robert Guido Alvaro Bobadilla',
    documento: 'https://munichumbivilcas.gob.pe/CERTIFICADOS-MPCH/SIGA-I-2025/CERT_72.pdf',
  },
};

function Certificados() {
  const [dni, setDni] = useState("");
  const [resultado, setResultado] = useState(null);
  const [error, setError] = useState("");

  const consultar = () => {
    setError("");
    setResultado(null);

    if (dni.trim().length !== 8) {
      setError("El DNI debe tener 8 dígitos.");
      return;
    }

    const data = DatosPersonal[dni];
    if (!data) {
      setError("No existe un certificado asociado a este DNI.");
      return;
    }

    setResultado(data);
  };

  return (
    <div className="cert-container">
      <h1>Consulta de Certificados</h1>

      <div className="search-box">
        <input
          type="text"
          placeholder="Ingrese DNI"
          maxLength="8"
          value={dni}
          onChange={(e) => setDni(e.target.value)}
        />
        <button onClick={consultar}>Buscar</button>
      </div>

      {error && <p className="error">{error}</p>}

      {resultado && (
        <div className="resultado">
          <h2>Certificado de: {resultado.nombre}</h2>

          {/* Mostrar PDF dentro de la página */}
          <iframe
            className="visor-pdf"
            src={resultado.documento}
            title="visor-certificado"
          />

          {/* Botón para abrir en otra pestaña */}
          <a href={resultado.documento} target="_blank" rel="noopener noreferrer">
            <button className="btn-externo">Imprimir</button>
          </a>
        </div>
      )}
    </div>
  );
};
export default Certificados;